import type React from "react";
import Layout from "../../../components/site/Layout/Layout";
import { Link } from "react-router-dom";

const TermsPage: React.FC = () => {
	return (
		<Layout>
			<div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
				<h1 className="text-3xl font-bold mb-8">利用規約</h1>

				<div className="prose prose-purple max-w-none">
					<p className="text-gray-600 mb-8">
						この利用規約（以下、「本規約」といいます。）は、大船渡学習ギルド（以下、「当団体」といいます。）がこのウェブサイト上で提供するサービス（以下、「本サービス」といいます。）の利用条件を定めるものです。登録ユーザーの皆さま（以下、「ユーザー」といいます。）には、本規約に従って、本サービスをご利用いただきます。
					</p>

					<section className="mb-8">
						<h2 className="text-2xl font-semibold mb-4">第1条（適用）</h2>
						<ol className="list-decimal list-inside space-y-2 text-gray-600">
							<li>
								本規約は、ユーザーと当団体との間の本サービスの利用に関わる一切の関係に適用されるものとします。
							</li>
							<li>
								当団体は本サービスに関し、本規約のほか、ご利用にあたってのルール等、各種の定め（以下、「個別規定」といいます。）をすることがあります。これら個別規定はその名称のいかんに関わらず、本規約の一部を構成するものとします。
							</li>
						</ol>
					</section>

					<section className="mb-8">
						<h2 className="text-2xl font-semibold mb-4">第2条（利用登録）</h2>
						<ol className="list-decimal list-inside space-y-2 text-gray-600">
							<li>
								本サービスにおいては、登録希望者が本規約に同意の上、当団体の定める方法によって利用登録を申請し、当団体がこれを承認することによって、利用登録が完了するものとします。
							</li>
							<li>
								当団体は、利用登録の申請者に以下の事由があると判断した場合、利用登録の申請を承認しないことがあり、その理由については一切の開示義務を負わないものとします。
							</li>
							<ul className="list-disc list-inside ml-6 space-y-2">
								<li>利用登録の申請に際して虚偽の事項を届け出た場合</li>
								<li>本規約に違反したことがある者からの申請である場合</li>
								<li>その他、当団体が利用登録を相当でないと判断した場合</li>
							</ul>
						</ol>
					</section>

					<section className="mb-8">
						<h2 className="text-2xl font-semibold mb-4">
							第3条（アカウント管理）
						</h2>
						<ol className="list-decimal list-inside space-y-2 text-gray-600">
							<li>
								ユーザーは、自己の責任において、本サービスのアカウントを適切に管理するものとします。
							</li>
							<li>
								ユーザーは、いかなる場合にも、アカウントを第三者に譲渡または貸与することはできません。
							</li>
							<li>
								当団体は、ユーザーIDとパスワードの組み合わせが登録情報と一致してログインされた場合には、そのユーザーIDを登録しているユーザー自身による利用とみなします。
							</li>
							<li>
								アカウントの管理不十分、使用上の過誤、第三者の使用等による損害の責任はユーザーが負うものとし、当団体は一切の責任を負いません。
							</li>
						</ol>
					</section>

					<section className="mb-8">
						<h2 className="text-2xl font-semibold mb-4">第4条（禁止事項）</h2>
						<p className="text-gray-600 mb-4">
							ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。
						</p>
						<ol className="list-decimal list-inside space-y-2 text-gray-600">
							<li>法令または公序良俗に違反する行為</li>
							<li>犯罪行為に関連する行為</li>
							<li>
								当団体のサーバーまたはネットワークの機能を破壊したり、妨害したりする行為
							</li>
							<li>当団体のサービスの運営を妨害するおそれのある行為</li>
							<li>他のユーザーに関する個人情報等を収集または蓄積する行為</li>
							<li>他のユーザーに成りすます行為</li>
							<li>
								当団体のサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為
							</li>
							<li>
								他のユーザーの知的財産権、肖像権、プライバシー、名誉その他の権利または利益を侵害する行為
							</li>
							<li>
								過度に暴力的な表現、露骨な性的表現、人種、国籍、信条、性別、社会的身分、門地等による差別につながる表現、自殺、自傷行為、薬物乱用を誘引または助長する表現、その他反社会的な内容を含む表現を投稿する行為
							</li>
							<li>
								営業、宣伝、広告、勧誘、その他営利を目的とする行為（当団体の認めたものを除きます。）
							</li>
							<li>他のユーザーに対する嫌がらせや誹謗中傷を目的とする行為</li>
							<li>その他、当団体が不適切と判断する行為</li>
						</ol>
					</section>

					<section className="mb-8">
						<h2 className="text-2xl font-semibold mb-4">
							第5条（本サービスの提供の停止等）
						</h2>
						<ol className="list-decimal list-inside space-y-2 text-gray-600">
							<li>
								当団体は、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。
								<ul className="list-disc list-inside ml-6 space-y-2">
									<li>
										本サービスにかかるコンピュータシステムの保守点検または更新を行う場合
									</li>
									<li>
										地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合
									</li>
									<li>コンピュータまたは通信回線等が事故により停止した場合</li>
									<li>その他、当団体が本サービスの提供が困難と判断した場合</li>
								</ul>
							</li>
							<li>
								当団体は、本サービスの提供の停止または中断により、ユーザーまたは第三者が被ったいかなる不利益または損害について、理由を問わず一切の責任を負わないものとします。
							</li>
						</ol>
					</section>

					<section className="mb-8">
						<h2 className="text-2xl font-semibold mb-4">第6条（著作権）</h2>
						<ol className="list-decimal list-inside space-y-2 text-gray-600">
							<li>
								ユーザーは、自ら著作権等の必要な知的財産権を有するか、または必要な権利者の許諾を得た文章、画像や映像等の情報のみ、本サービスを利用し、投稿または編集することができるものとします。
							</li>
							<li>
								ユーザーが本サービスを利用して投稿または編集した文章、画像、映像等の著作権については、当該ユーザーその他既存の権利者に留保されるものとします。ただし、当団体は、本サービスを利用して投稿または編集された文章、画像、映像等を利用できるものとし、ユーザーは、この利用に関して、著作者人格権を行使しないものとします。
							</li>
							<li>
								前項本文の定めるものを除き、本サービスおよび本サービスに関連する一切の情報についての著作権およびその他知的財産権はすべて当団体または当団体にその利用を許諾した権利者に帰属し、ユーザーは無断で複製、譲渡、貸与、翻訳、改変、転載、公衆送信（送信可能化を含みます。）、伝送、配布、出版、営業使用等をしてはならないものとします。
							</li>
						</ol>
					</section>

					<section className="mb-8">
						<h2 className="text-2xl font-semibold mb-4">
							第7条（利用制限および登録抹消）
						</h2>
						<ol className="list-decimal list-inside space-y-2 text-gray-600">
							<li>
								当団体は、以下の場合には、事前の通知なく、ユーザーに対して、本サービスの全部もしくは一部の利用を制限し、またはユーザーとしての登録を抹消することができるものとします。
								<ul className="list-disc list-inside ml-6 space-y-2">
									<li>本規約のいずれかの条項に違反した場合</li>
									<li>登録事項に虚偽の事実があることが判明した場合</li>
									<li>
										当団体からの問い合わせその他の回答を求める連絡に対して30日間以上応答がない場合
									</li>
									<li>
										その他、当団体が本サービスの利用を適当でないと判断した場合
									</li>
								</ul>
							</li>
							<li>
								当団体は、本条に基づき当団体が行った行為によりユーザーに生じた損害について、一切の責任を負いません。
							</li>
						</ol>
					</section>

					<section className="mb-8">
						<h2 className="text-2xl font-semibold mb-4">第8条（退会）</h2>
						<ol className="list-decimal list-inside space-y-2 text-gray-600">
							<li>
								ユーザーは、当団体の定める退会手続により、本サービスから退会できるものとします。
							</li>
							<li>
								退会後の利用者情報の取扱いについては、第9条の規定に従うものとします。
							</li>
						</ol>
					</section>

					<section className="mb-8">
						<h2 className="text-2xl font-semibold mb-4">
							第9条（保証の否認および免責事項）
						</h2>
						<ol className="list-decimal list-inside space-y-2 text-gray-600">
							<li>
								当団体は、本サービスに事実上または法律上の瑕疵（安全性、信頼性、正確性、完全性、有効性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害などを含みます。）がないことを明示的にも黙示的にも保証しておりません。
							</li>
							<li>
								当団体は、本サービスに起因してユーザーに生じたあらゆる損害について、当団体の故意又は重過失による場合を除き、一切の責任を負いません。
							</li>
							<li>
								当団体は、本サービスに関して、ユーザーと他のユーザーまたは第三者との間において生じた取引、連絡または紛争等について一切責任を負いません。
							</li>
						</ol>
					</section>

					<section className="mb-8">
						<h2 className="text-2xl font-semibold mb-4">
							第10条（規約の変更）
						</h2>
						<ol className="list-decimal list-inside space-y-2 text-gray-600">
							<li>
								当団体は、必要と判断した場合には、ユーザーに通知することなくいつでも本規約を変更することができるものとします。
							</li>
							<li>
								変更後の規約は、当団体ウェブサイトに掲示された時点から効力を生じるものとします。
							</li>
						</ol>
					</section>

					<section className="mb-8">
						<h2 className="text-2xl font-semibold mb-4">
							第11条（通知または連絡）
						</h2>
						<ol className="list-decimal list-inside space-y-2 text-gray-600">
							<li>
								ユーザーと当団体との間の通知または連絡は、当団体の定める方法によって行うものとします。
							</li>
							<li>
								当団体は、ユーザーから、当団体が別途定める方式に従った変更届け出がない限り、現在登録されている連絡先が有効なものとみなして当該連絡先へ通知または連絡を行い、これらは、発信時にユーザーへ到達したものとみなします。
							</li>
						</ol>
					</section>

					<section className="mb-8">
						<h2 className="text-2xl font-semibold mb-4">
							第12条（準拠法・裁判管轄）
						</h2>
						<ol className="list-decimal list-inside space-y-2 text-gray-600">
							<li>本規約の解釈にあたっては、日本法を準拠法とします。</li>
							<li>
								本サービスに関して紛争が生じた場合には、盛岡地方裁判所を第一審の専属的合意管轄裁判所とします。
							</li>
						</ol>
					</section>

					<div className="mt-12 text-gray-600">
						<p>2024年4月1日 制定</p>
					</div>

					<div className="mt-8 p-4 bg-gray-50 rounded-lg">
						<p className="text-sm text-gray-600">
							ご不明な点がございましたら、
							<Link
								to="/contact"
								className="text-purple-600 hover:text-purple-500"
							>
								お問い合わせフォーム
							</Link>
							よりご連絡ください。
						</p>
					</div>
				</div>
			</div>
		</Layout>
	);
};

export default TermsPage;
